
angular.module('dybTags', ['ui.router']);
